var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_vm._v("欢迎来到广农数链")])}
var staticRenderFns = []

export { render, staticRenderFns }